import List from "list.js"

List.prototype.activeFilters = []

List.prototype.sortAttr = void 0

List.prototype.sortAsc = true

List.prototype.registerFilterOption = function (input, attr, matchFnc) {
  var activeFilters, list
  activeFilters = this.activeFilters
  list = this
  $(input).change(function (el) {
    var activeFilterFunctions, attrFilter, filterVal
    filterVal =
      el.target.type === "checkbox"
        ? $(el.target).is(":checked")
        : el.target.value
    if (
      (filterVal.length > 0 && filterVal !== "&nbsp;") ||
      el.target.type === "checkbox"
    ) {
      attrFilter = function (item) {
        var itemVal
        itemVal = item.values()[attr]
        return matchFnc(itemVal, filterVal)
      }
      activeFilters[attr] = attrFilter
    } else {
      delete activeFilters[attr]
    }
    activeFilterFunctions = []
    Object.keys(activeFilters).forEach(function (attrFilter) {
      return activeFilterFunctions.push(activeFilters[attrFilter])
    })
    return list.filter(function (item) {
      return activeFilterFunctions.every(function (f) {
        return f(item)
      })
    })
  })
  if ($(input).val().length > 0) {
    return $(input).trigger("change")
  }
}

List.prototype.registerSortOption = function (el, attr) {
  var list, toggleSorting
  list = this
  list.alphabet = "AÄBCDEFGHIJKLMNOÖPQRSßTUÜVXYZaäbcdefghijklmnoöpqrstuüvxyz"
  toggleSorting = function (attr, el) {
    var d
    list.sortAsc = !list.sortAsc
    if (attr !== list.sortAttr) {
      list.sortAttr = attr
      list.sortAsc = true
    }
    d = list.sortAsc ? "asc" : "desc"
    $("." + list.sortClass).removeClass("active asc desc")
    $(el).addClass("active")
    $(el).addClass(d)
    return list.sort(attr, {
      order: d,
    })
  }
  return $(el).click(function () {
    return toggleSorting(attr, el)
  })
}

List.prototype.registerSearchForm = function (id) {
  var list
  list = this
  return $("#" + id).on("keyup", function () {
    var searchString
    searchString = $(this).val()
    return list.search(searchString)
  })
}

List.exactMatch = function (itemVal, filterVal) {
  return itemVal === filterVal
}

List.subsetMatch = function (itemVal, filterVal) {
  var itemVals
  if (!itemVal) {
    return false
  }
  itemVals = itemVal.split(",")
  return filterVal.split(",").every(function (el) {
    return itemVals.includes(el)
  })
}

List.containsAny = function (itemVal, filterVal) {
  var itemVals
  if (!itemVal) {
    return false
  }
  itemVals = itemVal.split(",")
  return filterVal.split(",").some(function (el) {
    return itemVals.includes(el)
  })
}

List.booleanMatch = function (val) {
  return function (itemVal, filterVal) {
    if (filterVal) {
      return itemVal === val
    } else {
      return itemVal !== val
    }
  }
}
